const routes = [
    {
        "route": "/",
        "menuName": "Home",
        "icon": "home",
        "exact": true,
        "subMenu": []
    },
    {
        "route": "",
        "menuName": "Masters",
        "icon": "list",
        "subMenu": [

            {
                "route": "/department",
                "menuName": "Department",
                "icon": "tty",
            }, {
                "route": "/assets",
                "menuName": "Assets",
                "icon": "box",
            }, {
                "route": "/asset-list",
                "menuName": "Assets List",
                "icon": "list alternate outline",
            }, {
                "route": "/shift",
                "menuName": "Shift",
                "icon": "clock outline",
            }, {
                "route": "/post",
                "menuName": "Post",
                "icon": "universal access",
            }, {
                "route": "/employee",
                "menuName": "Employee",
                "icon": "user outline",
            }
        ]
    }, {
        "route": "",
        "menuName": "Transaction",
        "icon": "text height",
        "subMenu": [
            {
                "route": "/duty-roster",
                "menuName": "Duty Roster",
                "icon": "random",
            }
        ]
    }, {
        "route": "/reports",
        "menuName": "Reports",
        "icon": "file text",
        "subMenu": []
    }
]


export default routes;